import React, { useState } from 'react';
import { useAuth } from 'hooks/useAuth'; // Import the login function from your Auth context
import { useNavigate } from 'react-router-dom'; // Import useNavigate for redirection

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { login } = useAuth(); // Extract the login function from useAuth
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const handleLogin = async e => {
    e.preventDefault(); // Prevent form from reloading the page
    setError('');
    setIsLoading(true);

    try {
      await login(username, password); // Call the login function
      navigate('/'); // Redirect to the home page after successful login
    } catch (err) {
      console.error('Login error:', err);
      setError('Invalid username or password');
    } finally {
      setIsLoading(false); // Stop the loading spinner
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h3 className="text-center">Login</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleLogin}>
                {' '}
                {/* Use handleLogin for form submission */}
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">
                    Username
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    value={username}
                    onChange={e => setUsername(e.target.value)} // Update username state
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)} // Update password state
                    required
                  />
                </div>
                <button
                  type="submit" // Use submit type for proper form handling
                  className="btn btn-primary w-100"
                  disabled={isLoading} // Disable button while loading
                >
                  {isLoading ? 'Logging in...' : 'Login'}{' '}
                  {/* Show loading feedback */}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
